import { LinearGradient } from 'expo-linear-gradient';
import { cssInterop } from 'nativewind';
import * as React from 'react';
import { View } from 'react-native';

cssInterop(LinearGradient, { className: 'style' });

const GlowGradient = LinearGradient as React.ComponentType<
  React.ComponentProps<typeof LinearGradient> & { className?: string }
>;

export function LandingGlow() {
  return (
    <View pointerEvents="none" className="absolute inset-0 overflow-hidden bg-[#070a10]">
      <GlowGradient
        className="absolute inset-0 opacity-100"
        colors={['#070a10', '#070a10', '#070a10']}
        end={{ x: 0.5, y: 1 }}
        start={{ x: 0.5, y: 0 }}
      />
      <GlowGradient
        className="absolute inset-x-0 -top-20 h-[58%] opacity-30"
        colors={['rgba(239,78,46,0.34)', 'rgba(239,78,46,0.08)', 'rgba(239,78,46,0)']}
        end={{ x: 0.5, y: 1 }}
        start={{ x: 0.5, y: 0 }}
      />
      <GlowGradient
        className="absolute -right-24 top-0 h-full w-[70%] opacity-20"
        colors={['rgba(239,78,46,0)', 'rgba(239,78,46,0.22)', 'rgba(239,78,46,0)']}
        end={{ x: 1, y: 0.7 }}
        start={{ x: 0, y: 0.2 }}
      />
      <GlowGradient
        className="absolute inset-0 opacity-20"
        colors={['rgba(200,130,40,0.08)', 'rgba(239,78,46,0.05)', 'rgba(255,255,255,0)']}
        end={{ x: 1, y: 1 }}
        start={{ x: 0, y: 0 }}
      />
      <GlowGradient
        className="absolute inset-x-0 bottom-0 h-[42%] opacity-60"
        colors={['rgba(7,10,16,0)', '#070a10']}
        end={{ x: 0.5, y: 1 }}
        start={{ x: 0.5, y: 0 }}
      />
    </View>
  );
}
